import React from "react";
import { FaSignOutAlt } from "react-icons/fa";
import useLogout from '../Hooks/Auth/useLogout';
import ConfirmLogoutModal from './ConfirmLogoutModal';

const LogoutButton = ({ className = "", children, collapsed = false }) => {
  const {
    isLoggingOut,
    showConfirmModal,
    openConfirmModal,
    closeConfirmModal,
    confirmLogout
  } = useLogout();

  return (
    <>
      <button
        onClick={openConfirmModal}
        disabled={isLoggingOut}
        className={`flex items-center ${collapsed ? 'justify-center gap-0 px-2' : 'gap-3 px-5'} py-2 rounded-lg text-light hover:bg-light hover:text-main1 transition w-full text-center disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
        title={collapsed ? (isLoggingOut ? "جاري تسجيل الخروج..." : "تسجيل الخروج") : undefined}
        aria-label={isLoggingOut ? "جاري تسجيل الخروج..." : "تسجيل الخروج"}
      >
        <FaSignOutAlt />
        <span className={`transition-all duration-300 ${collapsed ? 'opacity-0 w-0 overflow-hidden' : 'opacity-100'}`}>
          {children || (isLoggingOut ? "جاري تسجيل الخروج..." : "تسجيل الخروج")}
        </span>
      </button>

      {/* النافذة المنبثقة لتأكيد تسجيل الخروج */}
      <ConfirmLogoutModal
        isOpen={showConfirmModal}
        onClose={closeConfirmModal}
        onConfirm={confirmLogout}
        isLoading={isLoggingOut}
      />
    </>
  );
};

export default LogoutButton; 
